/**
 * Sidebar de navegación del panel admin
 * Sprint 7 - HU-FE-04
 */

import { NavLink } from 'react-router-dom';

interface SidebarProps {
    isOpen: boolean;
    onClose: () => void;
    onLogout: () => void;
}

const NAV_ITEMS = [
    { to: '/admin', icon: '🏠', label: 'Dashboard', end: true },
    { to: '/admin/payments', icon: '💳', label: 'Pagos', end: false },
    { to: '/admin/payouts/settings', icon: '💸', label: 'Comisión proveedores', end: false },
    { to: '/admin/billing/invoices', icon: '🧾', label: 'Facturación Troquero', end: false },
    { to: '/admin/cargo-insurance', icon: '🛡️', label: 'Seguros de Mercancía', end: false },
    { to: '/admin/reported-ratings', icon: '🛡️', label: 'Reseñas', end: false },
    { to: '/admin/tracking', icon: '📍', label: 'Seguimiento', end: false },
    { to: '/admin/return-intents', icon: '↩️', label: 'Regresos', end: false },
    { to: '/chat', icon: '💬', label: 'Chats', end: false },
    { to: '/admin/push-monitor', icon: '🔔', label: 'Push Monitor', end: false },
    { to: '/admin/users', icon: '👥', label: 'Usuarios', end: false },
    { to: '/admin/map', icon: '🗺️', label: 'Mapa', end: false },
    { to: '/admin/legal-documents', icon: '📄', label: 'Documentos legales', end: false },
    { to: '/admin/system-settings', icon: '⚙️', label: 'Configuraciones del sistema', end: false },
    { to: '/admin/users/create', icon: '➕', label: 'Crear Admin', end: false },
] as const;

export function Sidebar({ isOpen, onClose, onLogout }: SidebarProps) {
    return (
        <>
            {/* Overlay para móvil */}
            {isOpen ? (
                <div
                    className="sidebar-overlay"
                    onClick={onClose}
                    aria-hidden="true"
                />
            ) : null}

            <aside className={`sidebar ${isOpen ? 'sidebar--open' : ''}`}>
                <div className="sidebar-header">
                    <span className="sidebar-logo">📦 MP</span>
                </div>

                <nav className="sidebar-nav">
                    {NAV_ITEMS.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.end}
                            className={({ isActive }) =>
                                `sidebar-link ${isActive ? 'sidebar-link--active' : ''}`
                            }
                            onClick={onClose}
                        >
                            <span className="sidebar-link-icon">{item.icon}</span>
                            <span className="sidebar-link-label">{item.label}</span>
                        </NavLink>
                    ))}
                </nav>

                <div className="sidebar-footer">
                    <button
                        type="button"
                        className="sidebar-link sidebar-logout"
                        onClick={onLogout}
                    >
                        <span className="sidebar-link-icon">🚪</span>
                        <span className="sidebar-link-label">Cerrar sesión</span>
                    </button>
                </div>
            </aside>
        </>
    );
}
